export default __webpack_public_path__ + "static/media/thumbnail_blog_26_1.f23a7176.png";